import React from 'react'
import './brand.scss'

type size = {
    isLiveChat?: boolean,
    size?: string
}

const Brand = ({isLiveChat, size} : size) => {
    return (
        <div className={
            'brand ' + 
            (size ? 'brand--small' : '')
        }>
            { !isLiveChat && 
                <div className="brand__logo"></div>
            }

            { isLiveChat &&
                <img src="/images/live_chat_icon.svg" 
                alt="BWS"
                className="brand__logo" />
            }
        </div>
    )
}

export default Brand
